import asJSONLDSnippet from './asJSONLDSnippet';

export default asJSONLDSnippet(({name, legalName, alternateName, url, logo, email, vatID, slogan, description, foundingDate, numberOfEmployees, address, contactPoint, hasMerchantReturnPolicy, sameAs}) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name,
  ...(legalName && {legalName}),
  ...(alternateName && {alternateName}),
  url,
  ...(logo && {logo}),
  ...(email && {email}),
  ...(vatID && {vatID}),
  ...(slogan && {slogan}),
  ...(description && {description}),
  ...(foundingDate && {foundingDate}),
  ...(numberOfEmployees && {numberOfEmployees: {'@type': 'QuantitativeValue', ...numberOfEmployees}}),
  ...(address && {address: {'@type': 'PostalAddress', ...address}}),
  ...(contactPoint && {contactPoint: {'@type': 'ContactPoint', ...contactPoint}}),
  ...(hasMerchantReturnPolicy && {hasMerchantReturnPolicy: {'@type': 'MerchantReturnPolicy', ...hasMerchantReturnPolicy}}),
  ...(sameAs && sameAs.length && {sameAs}),
}));



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDOrganization.js